/**
 * Purchase-unit arithmetic (migration 118). Storage is always in the item's
 * own unit; a purchase unit ("Bag 25 kg", factor 25) is only a way of TYPING
 * a quantity. Rounded to the 5-decimal scale of the quantity columns so a
 * converted number can never disagree with what the server stores.
 */

export interface PurchaseUnit {
  label: string
  factor: number
}

/** The item's purchase unit, or null when it is bought in its own unit. */
export function purchaseUnitOf(item: { purchase_unit_label?: string | null; purchase_unit_factor?: number | null }): PurchaseUnit | null {
  const label = item.purchase_unit_label?.trim()
  const factor = item.purchase_unit_factor
  if (!label || factor == null || !(factor > 0)) return null
  return { label, factor }
}

export function roundQty5(v: number): number {
  return Math.round(v * 1e5) / 1e5
}

/** 2 bags of 25 kg → 50 (kg). */
export function toBaseQty(qty: number, factor: number): number {
  return roundQty5(qty * factor)
}

/** 50 kg with 25 kg bags → 2 (bags). */
export function fromBaseQty(qty: number, factor: number): number {
  return factor > 0 ? roundQty5(qty / factor) : qty
}
